import Game1Loading from './game/loading/main';
import Game1Playing from './game/playing/main';
import Game1Clear from './game/clear/main';

import Game2Loading from './game2/loading/main';
import Game2Playing from './game2/playing/main';
import Game2Clear from './game2/clear/main';

import UrlUtils from '../../../common/utils/url';

let Scenes = [Game1Loading, Game1Playing, Game1Clear, Game2Loading, Game2Playing, Game2Clear];

const query = UrlUtils.getQuery();
if(parseInt(query.jump) === 2){
    Scenes = [Game2Loading, Game2Playing, Game2Clear];
}

export default Scenes;
